<template>
    <v-flex class="mx-2">
        <v-card class="establishment-description">
            <v-card-text class="info-container text ql-editor establishment-card">
                <v-stepper
                    :style="descriptionExpansionStyle"
                    :value="getStepperStep"
                    class="overflow-container elevation-0">
                    <v-stepper-items>
                        <!-- Establishment presentation text -->
                        <v-stepper-content step="1" class="px-2 px-md-6">
                            <div
                                :class="{ 'info-card': getStepperStep === 1 }"
                                tabindex="0"
                                v-html="presentationText"
                            />
                        </v-stepper-content>

                        <!-- Service description -->
                        <v-stepper-content step="2" class="px-2 px-md-6">
                            <div
                                :class="{ 'info-card': getStepperStep === 2 }"
                                tabindex="0"
                                v-html="serviceDescription"
                            />
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card-text>

            <v-card-actions>
                <v-layout>
                    <v-flex class="text-right">
                        <v-btn v-show="isOverflowing" text color="secondary" @click="toggleDescriptionExpansion">
                            <span v-if="isExpanded">
                                {{ $t('base.showLess') }}
                            </span>
                            <span v-else>
                                {{ $t('base.showMore') }}
                            </span>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-flex>
</template>
<script>
import { mapGetters } from 'vuex';
import { min } from 'lodash';

const MAX_CONTAINER_HEIGHT = 245;

export default {
    name: 'welcome-message-box',
    props: {
        presentationText: { type: HTMLObjectElement, required: true },
        selectedService: { type: Object, required: false, default: () => undefined },
    },
    data() {
        return {
            isExpanded: false,
            isOverflowing: false,
            lastKnownContainerHeight: null,
        };
    },
    mounted() {
        this.resetExpansionStatus();
    },
    watch: {
        selectedService() {
            this.resetExpansionStatus();
        },
        isSmallDevice() {
            this.resetExpansionStatus();
        },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),

        /**
         * Returns the max-height or not based on the fact that we should be expanded or not.
         * @return {{}}
         */
        descriptionExpansionStyle() {
            if (!this.isExpanded) {
                return {
                    'max-height': `${MAX_CONTAINER_HEIGHT}px`,
                };
            }
            return {
                'max-height': `100000px`,
            };
        },

        /**
         * Compute the service description depending on locale
         * and current selected service
         * @returns {null|string}
         */
        serviceDescription() {
            if (this.selectedService && this.selectedService[`description${this.upperLocale}`]) {
                return this.selectedService[`description${this.upperLocale}`];
            }
            return null;
        },

        /**
         * Display only service description in header if in desktop view.
         * @returns int
         */
        getStepperStep() {
            return this.serviceDescription ? 2 : 1;
        },
    },
    methods: {
        resetExpansionStatus() {
            this.isOverflowing = false;
            this.isExpanded = false;
            this.lastKnownContainerHeight = null;
            setTimeout(this.detectDescriptionOverflow, 1000);
        },
        toggleDescriptionExpansion() {
            this.isExpanded = !this.isExpanded;
        },

        /**
         * Queries the proper container for the description and decides if we need to show or hide the toggle button.
         */
        detectDescriptionOverflow() {
            if (!this.lastKnownContainerHeight) {
                const containerElement = document.querySelector('.info-container');
                this.lastKnownContainerHeight = min([containerElement.clientHeight, MAX_CONTAINER_HEIGHT]);
            }

            const contentElement = document.querySelector('.info-card');
            this.isOverflowing = contentElement.clientHeight > this.lastKnownContainerHeight;
        },
    },
};
</script>
